import { jsx as _jsx } from "react/jsx-runtime";
import { Accordion } from '@purpurds/purpur/accordion';
import styled from 'styled-components';
import NOB from '../../../../../constants/language-strings';
import { Products } from './products';
const StyledAccordion = styled(Accordion) `
  margin: 0 2rem;

  button {
    padding: 0.75rem;
  }

  @media (max-width: 640px) {
    margin: 0 1.2rem;
  }
`;
export const ProductList = ({ productList }) => (_jsx(StyledAccordion, { titleTag: "h6", titleVariant: "title-200", children: _jsx(Accordion.Item, { title: NOB.PRODUCT_LIST.TODAYS_PRODUCT_LIST, children: _jsx(Products, { productList: productList }) }) }));
